module.exports = __webpack_public_path__ + "static/img/404.f8abae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/404.png
// module id = NvXF
// module chunks = 21